import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const ShippingRoutes: Routes = [
  {
    path: "shipping",
    loadComponent: () =>
      import("./shipping/shipping.component").then((m) => m.ShippingComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./shipping-list/shipping-list.component").then(
            (m) => m.ShippingListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./shipping-form/shipping-form.component").then(
            (m) => m.ShippingFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./shipping-form/shipping-form.component").then(
            (m) => m.ShippingFormComponent,
          ),
      },
    ],
  },
];
